import { DataProxy } from 'apollo-cache';
import { produce } from 'immer';

import { pagesQuery } from '../../components/LeftContainer/graphql';
import { PagesQuery } from '../../generated/graphql';

function addItemToPage<T extends any>(cache: DataProxy, pageId: number, item: T, close?: Function): void {
  if (!item) {
    return;
  }

  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  if (pages?.length) {
    const updatedPages = produce(pages, draft => {
      const page = draft.find(p => p.id === pageId);

      if (page) {
        page.items = page.items || [];
        page.items.push(item as any);
      }
    });

    cache.writeQuery({
      query: pagesQuery,
      data: { pages: updatedPages },
    });
  }

  if (close) close(item);
}

export default addItemToPage;
